import { getGlobalHeaders, clearGuestToken } from "./guestTokenService";

class ApiService {
  async getAuthHeaders() {
    return await getGlobalHeaders();
  }

  async refreshToken() {
    clearGuestToken();
    return await getGlobalHeaders();
  }

  // Initialize token
  async initializeToken() {
    try {
      await getGlobalHeaders();
      console.log("Guest token initialized successfully");
      return true;
    } catch (error) {
      console.error("Failed to initialize guest token:", error);
      return false;
    }
  }
}

const apiService = new ApiService();
export default apiService;
